module.exports = __webpack_public_path__ + "img/light-back.94a0d98c.svg";